import { render, staticRenderFns } from "./CreateGroupWrapper.vue?vue&type=template&id=a7ec928a"
import script from "./CreateGroupWrapper.vue?vue&type=script&lang=js"
export * from "./CreateGroupWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports